module.exports = __webpack_public_path__ + "img/chinesecompany29.5693eb74.png";